export default __webpack_public_path__ + "static/media/page.cdcb5168.svg";